import { useEffect, useState } from "react";
import { Award } from "lucide-react";
import { api } from "@/lib/api";
import SEO from "@/components/SEO";
import QualityCertificates from "@/components/QualityCertificates";

export default function Certifications() {
  const [items, setItems] = useState([]);
  useEffect(() => {
    api.get("/certifications").then((r) => setItems(r.data));
  }, []);

  return (
    <>
      <SEO title="Certifications" description="Forage's regulatory certifications and quality accreditations — GMP, ISO 9001:2015, WHO-GMP, GLP and Export House status." path="/certifications" />

      <section className="bg-[#0B2545] text-white py-24 px-6 md:px-12 lg:px-24 relative overflow-hidden">
        <div className="absolute inset-0 grid-pattern opacity-20" />
        <div className="container-fr relative">
          <span className="overline text-[#2A9D8F]">Certifications & Compliance</span>
          <h1 className="font-display text-4xl md:text-5xl lg:text-6xl font-black mt-3 leading-tight max-w-3xl">
            Audited, accredited and export-ready.
          </h1>
          <p className="text-lg text-slate-300 mt-6 max-w-2xl">
            Our certifications reflect the rigour we apply to manufacturing,
            laboratory testing, documentation and regulatory compliance.
          </p>
        </div>
      </section>

      {/* Featured Certificates with PDF preview + download */}
      <QualityCertificates />

      <section className="section-padding bg-white">
        <div className="container-fr">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {items.map((c, i) => (
              <div
                key={c.id}
                data-testid={`cert-card-${c.id}`}
                className="bg-white rounded-xl border border-slate-200 overflow-hidden card-lift fade-up"
                style={{ animationDelay: `${i * 60}ms` }}
              >
                <div className="h-52 w-full bg-slate-100 overflow-hidden">
                  {c.image_url && (
                    <img src={c.image_url} alt={c.title} loading="lazy" className="w-full h-full object-cover" />
                  )}
                </div>
                <div className="p-6">
                  <Award className="text-[#2A9D8F] mb-3" size={22} />
                  <h3 className="font-display text-xl font-bold text-[#0B2545]">{c.title}</h3>
                  <div className="text-xs uppercase tracking-wider text-slate-500 mt-1">{c.issuer}</div>
                  <p className="text-sm text-slate-600 mt-3 leading-relaxed">{c.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
